import { getFunctions, connectFunctionsEmulator, httpsCallable } from 'firebase/functions';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import app from '../firebase';

// Get the Firebase Functions instance
const functions = getFunctions(app);
const auth = getAuth(app);

// Connect to the emulator if in development mode
if (import.meta.env.DEV) {
  try {
    // Check if we're running locally
    const isLocalhost = window.location.hostname === 'localhost';
    if (isLocalhost) {
      connectFunctionsEmulator(functions, 'localhost', 5001);
      //console.log('Connected to Firebase Functions emulator');
    }
  } catch (error) {
    console.error('Failed to connect to Functions emulator:', error);
  }
}

// Export the functions instance
export { functions, httpsCallable };

// Helper function to create a callable function with proper error handling and auth token refresh
export const createCallable = (name: string, requireAuth: boolean = true) => {
  const callable = httpsCallable(functions, name);

  return async (data: any) => {
    try {
      // Get the current user
      const user = auth.currentUser;

      // Only check authentication if required
      if (requireAuth) {
        if (!user) {
          throw new Error('User must be authenticated to call this function');
        }

        // Refresh the auth token before making the call
        await user.getIdToken(true);
      }

      // Validate the data object
      if (!data || typeof data !== 'object') {
        throw new Error('Invalid data object');
      }

      // Make the function call
      const result = await callable(data);

      return result.data;
    } catch (error: any) {
      console.error(`Error calling function ${name}:`, error);
      throw error;
    }
  };
};

// Define specific callable functions
export const trackGoalCompletion = createCallable('trackGoalCompletion');
export const useAction = createCallable('useAction');
export const addActions = createCallable('addActions');
export const saveGameState = createCallable('saveGameState');
export const createUserDocument = createCallable('createUserDocument');
export const updateUserLogin = createCallable('updateUserLogin');
